import React, { useEffect, useState } from "react"
import { Route, Routes as SwitchRoutes, useLocation, useNavigate } from "react-router-dom"
import { Container, Box, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import Header from "./components/Header"
import Footer from "./components/Footer"
import Landing from "./components/Landing"
// import AppInfo from "./AppInfo/AppInfo"
// import Licences from "./Licences/Licences"
import Partner from "./Partner/Partner"
// import Checkout from "./Checkout/Checkout"
import About from "./About/About"
import Impressum from "./Impressum/Impressum"
import Datenschutz from "./Impressum/Datenschutz"
import AGB from "./Impressum/AGB"
// import Kontakt from "./Kontakt/Kontakt"

import Login from "./Login/Login"
import ValidateEmail from "./ValidateEmail/ValidateEmail"
import ForgotPassword from "./ForgotPassword/ForgotPassword"
import CookieFormular from "./components/CookieFormular"
import {
  F_INDEX,
  F_START_ABOUT,
  F_START_AGB,
  F_START_DATENSCHUTZ,
  F_START_EMAIL_VALIDATION,
  F_START_FORGOT_PASSWORD,
  F_START_IMPRESSUM,
  F_START_LOGIN,
  F_START_PARTNER,
  F_START_RESET_PASSWORD,
} from "../../constants/routes"
import ResetPassword from "./ForgotPassword/ResetPassword"

// const tabs = {
//   "Von Schülern - Für Schüler": About,
//   // "Bookay Web App": AppInfo,
//   Partnerschulen: Partner,
//   // "Lizenzen und Module": Licences,
//   // Kontakt: Kontakt,
// }

// const pages = {
//   ...tabs,
//   landing: Landing,
//   impressum: Impressum,
//   datenschutz: Datenschutz,
//   agb: AGB,
//   checkout: Checkout,
//   login: Login,
//   forgot: ForgotPassword,
//   validate: ValidateEmail,
//   validateCheckout: ForgotPassword,
// }

const StartRouter = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const theme = useTheme()

  const [showAppCard, setShowAppCard] = useState(false)

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  useEffect(() => {
    setShowAppCard(isMobile)
  }, [isMobile])

  useEffect(() => {
    const routeToShowAppCard = [F_INDEX]

    if (isMobile && routeToShowAppCard.includes(location.pathname)) {
      setShowAppCard(true)
    } else {
      setShowAppCard(false)
    }
  }, [isMobile, location])

  const props = {
    isMobile: isMobile,
  }

  return (
    <>
      <Container maxWidth="lg" role="main">
        <Header />
        {showAppCard && (
          // {/* {showLoginField && currentPage !== "login" && currentPage !== "validate" && currentPage !== "forgot" && currentPage !== "validateCheckout" ? ( */}
          <Box
            onClick={() => navigate(F_START_LOGIN)}
            sx={{
              width: "100%",
              height: "auto",
              backgroundColor: "rgba(152, 227, 156, 0.4)",
              border: "2px solid",
              borderColor: "#98e39c",
              // borderColor: "primary.main",
              borderRadius: "4px",
              my: 2,
              p: 2,
            }}>
            <Typography align="center" sx={{ display: "inline-flex", justifyContent: "center", width: "100%", cursor: "pointer" }}>
              Zur App <KeyboardArrowRightIcon />
            </Typography>
          </Box>
        )}

        <SwitchRoutes location={location}>
          <Route path="/" element={<Landing {...props} />} />
          <Route path={F_START_ABOUT} element={<About {...props} />} />
          <Route path={F_START_PARTNER} element={<Partner {...props} />} />
          <Route path={F_START_IMPRESSUM} element={<Impressum {...props} />} />
          <Route path={F_START_DATENSCHUTZ} element={<Datenschutz {...props} />} />
          <Route path={F_START_AGB} element={<AGB {...props} />} />

          <Route path={F_START_LOGIN} element={<Login {...props} />} />
          <Route path={F_START_FORGOT_PASSWORD} element={<ForgotPassword {...props} />} />
          <Route path={F_START_RESET_PASSWORD} element={<ResetPassword {...props} />} />
          <Route path={F_START_EMAIL_VALIDATION} element={<ValidateEmail {...props} />} />

          <Route path="*" element={<Landing {...props} />} />
        </SwitchRoutes>

        {/* 
        <CurrentPageElement
          isSchoolForgotPW={currentPage === "validateCheckout"}
          userData={userData?.role === "Schuladmin" ? userData : null}
          setCurrentPage={setCurrentPage}
        /> */}
      </Container>
      <Footer />
      <CookieFormular />
    </>
  )
}

export default StartRouter
